import type { IServices } from "../useMarketingChannelsServices";
import type { TimeGranularity } from "app/components/widget/widget-utilities/time-granularity";

export const resolveCurrentCategory = (services: IServices) => {
    const apiParams = services?.navigator.getParams();
    return services.categoryService.categoryQueryParamToCategoryObject(apiParams.category);
};

export const resolveCurrentGranularity = (services: IServices): TimeGranularity => {
    const { duration } = services.navigator.getParams();
    return duration === "28d" ? "Daily" : "Monthly";
};

export const resolveCurrentDuration = (services: IServices) => {
    const { duration } = services.navigator.getParams();
    return services.durationService.getDurationData(duration);
};
